/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import {
  Button,
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { FormGroup } from 'reactstrap';
import SelectInput from '~/components/selectInput/SelectInput';
import api from '~/services/api';
import { gridGroupDataSource } from '../../GruposServices';
import { Container } from './styles';

function CardLista() {
  const history = useHistory();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);
  const [isSelected, setIsSelected] = useState(false);
  const [form, setForm] = useState({ idPessoaEmpresa: 0 });

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }
  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];
  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  const [companyData, setCompanyData] = useState([{}]);

  useEffect(() => {
    async function getData() {
      const params = {
        skip: 0,
        take: 1000,
      };
      await api
        .get(`/Pessoa/GetPessoaPaginado?${qs.stringify(params)}`)
        .then((response) => {
          const { data } = response.data;
          setCompanyData(data);
        });
    }
    getData();
  }, []);

  return (
    <Container>
      <FormGroup>
        <SelectInput
          margin="0"
          width="100%"
          label="Selecione a empresa: "
          form={form}
          valueKey="idPessoaEmpresa"
          labelKey="razaoSocialNome"
          setForm={setForm}
          value={form.idPessoaEmpresa}
          options={companyData}
          placeholder="Escolha uma opção"
          state="idPessoaEmpresa"
          onChange={() => {
            setIsSelected(false);
            setTimeout(() => {
              setIsSelected(true);
            }, 250);
          }}
        />
      </FormGroup>
      {!isSelected ? (
        ''
      ) : (
        <>
          <section>
            <div className="sec1">
              <h1>Grupos</h1>
            </div>
            <div className="add">
              <Link to="/group/register" className="link">
                <FaPlus />
              </Link>
            </div>
          </section>

          <DataGrid
            dataSource={gridGroupDataSource(form.idPessoaEmpresa)}
            remoteOperations
            showBorders
            allowColumnReordering
            allowColumnResizing
            columnAutoWidth
            onOptionChanged={handleOptionChange}
          >
            <Editing mode="row" useIcons allowDeleting />
            <Pager
              visible
              showPageSizeSelector
              allowedPageSizes={[10, 15, 30]}
              showInfo
            />
            <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
            <FilterRow
              visible={filterOptions.showFilterRow}
              applyFilter={filterOptions.currentFilter}
            />
            <Column
              dataField="id"
              caption="ID grupo"
              filterOperations={false}
              alignment="left"
              allowFiltering
            >
              <HeaderFilter groupInterval={70} />
            </Column>
            <Column
              dataField="nome"
              caption="Nome grupo"
              filterOperations={false}
              alignment="left"
              allowFiltering
            >
              <HeaderFilter groupInterval={70} />
            </Column>
            <Column type="buttons" caption="Ações" width={100}>
              <Button
                hint="Editar"
                visible
                icon="edit"
                onClick={(e) => history.push(`/group/update/${e.row.data.id}`)}
              />
              <Button name="delete" visible hint="Deletar" icon="trash" />
            </Column>
          </DataGrid>
        </>
      )}
    </Container>
  );
}

export default CardLista;
